<template>
  <div>
    <div
      ref="taxiFormRef"
      class="repeater-form"
      :style="{ height: trHeight }"
    >
      <b-row
        v-for="(postTaxi, index) in post.postTaxis"
        :key="index"
        ref="taxiItemForm"
        class="pb-2"
      >
        <b-col cols="12">
          <div class="d-flex border rounded">
            <b-row class="flex-grow-1 p-2">
              <b-col lg="6">
                <validation-provider
                  #default="{ errors }"
                  name="Taxi"
                  rules="required"
                >
                  <b-form-group
                    label="Taxi"
                    label-for="taxi"
                  >
                    <v-select
                      :clearable="false"
                      :options="taxiList"
                      @input="(taxi) => taxiSelected(index, taxi)"
                      label="licenceNum"
                      v-model="postTaxi.taxi"
                    >
                      <template #option="{ firstName, lastName, licenceNum }">
                        <span>
                          <span class="font-weight-bolder">{{ licenceNum }}</span>
                          -
                          <small>{{ `${firstName} ${lastName}` }}</small>
                        </span>
                      </template>

                      <template #selected-option="{ firstName, lastName, licenceNum }">
                        <span>
                          <span class="font-weight-bolder">{{ licenceNum }}</span>
                          -
                          <small>{{ `${firstName} ${lastName}` }}</small>
                        </span>
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="6">
                <validation-provider
                  #default="{ errors }"
                  name="Rate"
                  rules="required"
                >
                  <b-form-group
                    label="Rate"
                    label-for="driver-rate"
                  >
                    <b-form-input
                      @input="(rate) => taxiRateChange(index, rate)"
                      v-model="postTaxi.taxiRate"
                      id="driver-rate"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <div
              class="pt-50 pr-50"
              v-if="(post.postTaxis.length > 1)"
            >
              <feather-icon
                size="16"
                icon="XIcon"
                class="cursor-pointer"
                @click="removeTaxi(index)"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-button
      size="sm"
      variant="primary"
      @click="addNewTaxi"
    >
      Add Taxi
    </b-button>
  </div>
</template>
<script>
import { BButton, BCol, BFormGroup, BFormInput, BRow } from 'bootstrap-vue';
import { computed, nextTick, onMounted, onUnmounted, ref } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import store from '@/store';
import usePostUtils from '@/modules/post/composables/usePostUtils';
import useTransition from '@/composables/useTransition';
import vSelect from 'vue-select';

export default {
  setup() {
    const { trAddHeight, trHeight, trSetHeight, trTrimHeight } = useTransition();
    const { getAccountCommission, storePost } = usePostUtils();

    const taxiList = store.getters['taxi/taxiFilterList'];

    const post = computed(() => store.getters['post/post']);

    const taxiFormRef = ref(null);
    const taxiItemForm = ref(null);

    onMounted(() => { initTrHeight(); });
    onUnmounted(() => { window.removeEventListener('resize', initTrHeight); });
    window.addEventListener('resize', initTrHeight);

    const initTrHeight = () => {
      trSetHeight(null);
      nextTick(() => { trSetHeight(taxiFormRef.value.scrollHeight); });
    };

    const addNewTaxi = () => {
      taxiFormRef.value.style.overflow = 'hidden';
      post.value.postTaxis.push({ taxi: null, taxiRate: 0.0, });
      storePost(post.value);

      nextTick(() => {
        trAddHeight(taxiItemForm.value[0].offsetHeight);
        setTimeout(() => { taxiFormRef.value.style.overflow = null; }, 350);
      });
    };

    const removeTaxi = (index) => {
      post.value.postTaxis.splice(index, 1);
      post.value.accountCommission = getAccountCommission(post.value);

      storePost(post.value);
      trTrimHeight(taxiItemForm.value[0].offsetHeight);
    };

    const taxiRateChange = (index, rate) => {
      post.value.postTaxis[index].taxiRate = +rate;
      post.value.accountCommission = getAccountCommission(post.value);
      storePost(post.value);
    };

    const taxiSelected = (index, taxi) => {
      if (taxi !== null) {
        post.value.postTaxis[index].taxi = taxi;
      } else {
        post.value.postTaxis[index].taxi = null;
        post.value.postTaxis[index].taxiRate = 0.0;
      }
      storePost(post.value);
    };

    return {
      post,
      taxiFormRef,
      taxiRateChange,
      taxiItemForm,
      taxiList,
      trHeight,

      //Method
      addNewTaxi,
      removeTaxi,
      taxiSelected,
    };
  },
  components: {
    BButton,
    BCol,
    BFormGroup,
    BFormInput,
    BRow,
    ValidationProvider,
    vSelect,
  },
};
</script>
<style lang="scss" scoped>
@import '~@core/scss/base/pages/app-invoice.scss';
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
